import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/TheBigTake.css';

const TheBigTake = () => {
  return (
    <>
      <Helmet>
        <title>The Big Take - Deep Dive Business Analysis | Redbox Global</title>
        <meta name="description" content="The Big Take delivers deep-dive analysis on the biggest business stories. Expert commentary and comprehensive coverage of the news that matters most to global markets." />
        <meta name="keywords" content="business analysis, market commentary, deep dive, business stories, expert analysis, market insights, business news analysis, detailed coverage" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/the-big-take" />
        <meta property="og:title" content="The Big Take - Deep Dive Business Analysis | Redbox Global" />
        <meta property="og:description" content="Deep-dive analysis on the biggest business stories with expert commentary and comprehensive market coverage." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/the-big-take" />
        <meta name="twitter:title" content="The Big Take - Deep Dive Business Analysis | Redbox Global" />
        <meta name="twitter:description" content="Deep-dive analysis on the biggest business stories with expert commentary and comprehensive market coverage." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/the-big-take" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>The Big Take</h1>
          <p className="page-subtitle">Deep-dive analysis on the stories shaping business and markets</p>
        </div>
        
        <div className="page-content">
          <a href="/article/banking-sector-transformation" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=600&fit=crop" alt="Banking analysis" />
              </div>
              <div className="featured-content">
               
                <h2>The Great Banking Transformation: Why JPMorgan's Strategy Will Reshape Finance</h2>
                <p>As traditional banking faces its biggest disruption in decades, we explore how JPMorgan Chase's $15 billion technology investment is setting a new standard for the industry. From AI-powered trading desks to blockchain settlements, this deep dive examines the strategic moves reshaping global finance—and why competitors are scrambling to keep pace.</p>
                <span className="article-meta">20 min read • Analysis by James Rodriguez</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/ev-market-shake-up" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=600&h=400&fit=crop" alt="Electric vehicles" />
                </div>
                <div className="article-content">
                
                  <h2>Tesla's China Problem: The EV Market Shake-Up</h2>
                  <p>Inside the fierce competition that's forcing Tesla to rethink its global dominance strategy.</p>
                  <span className="article-meta">18 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/ai-regulation-battle" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop" alt="AI regulation" />
                </div>
                <div className="article-content">
                  
                  <h2>The AI Regulation Battle Big Tech Can't Win</h2>
                  <p>Why new regulations could fundamentally change how tech giants develop and deploy AI.</p>
                  <span className="article-meta">16 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/energy-transition-economics" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=600&h=400&fit=crop" alt="Energy transition" />
                </div>
                <div className="article-content">
                  
                  <h2>The $4 Trillion Energy Transition Question</h2>
                  <p>How oil majors are placing massive bets on renewable energy—and what's at stake.</p>
                  <span className="article-meta">22 min read</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default TheBigTake;
